<template>
  <div>
    <div class="window">
      <p>window width: {{ width }}</p>
      <p>window height: {{ height }}</p>
    </div>

    <div class="top-title">
      <img class="title" src="@/assets/top/LASHIC_healthlab_logo.png" width="1880" height="203" loading="lazy" />
    </div>

    <router-link to="/login">
      <div>
        <img class="login-img" src="@/assets/top/アセット 2@2x.png" width="1942" height="347" loading="lazy" />
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Top",
    data: function () {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    }
  },
    methods: {
    handleResize: function() {
      // resizeのたびにこいつが発火するので、ここでやりたいことをやる
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    }
  },
  beforeDestroy() {
    document.body.className = "";
    window.removeEventListener('resize', this.handleResize)

  },
  mounted() {
    document.body.className = "color";
        window.addEventListener('resize', this.handleResize)
  },
};
</script>

<style>
.top-title {
  margin-top: 60%;
  display: inline-block;
  margin-bottom: 15%;
}
.sign-up {
  color: white;
  display: inline-block;
  font-weight: bold;
  font-size: 1.2rem;
  margin-top: 10%;
}
.window {
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/pages/Top.vue